<div class="mainframe">
    <div class="hcol-flex gap-half auto-grow" style="max-height: 100%">
        <div [ngClass]="'hcol-20'">
            <app-location-hierarchy-tree></app-location-hierarchy-tree>
        </div>

        <div [ngClass]="'hcol-80'" style="overflow-y: scroll">
            @if (!activeLocation && !waitInitialLocationsLoading) {
                <div style="text-align: center; margin-top: 4rem">
                    <h3 style="color: gray">Please select a location!</h3>
                </div>
            } @else if (waitInitialLocationsLoading === true) {
                <div style="text-align: center">
                    <p-progressSpinner
                        styleClass="w-4rem h-4rem"
                        strokeWidth="4"
                        animationDuration="1.5s"
                    ></p-progressSpinner>
                    <div class="mt-2 mb-2">{{ loadingStr }}</div>
                </div>
            } @else if (activeLocation) {
                <h5 style="display: flex; gap: 0.25rem; margin-bottom: 1rem">
                    @if (showLoading) {
                        ...
                    } @else if (activeLocation.parent) {
                        @if (activeLocation.parent.parent_uuid) {
                            <span>...</span>
                            <span class="pi pi-chevron-right"></span>
                            <span [classList]="LocationUtils.getIconForType(activeLocation.parent.type)"></span>
                            <a
                                tabindex="0"
                                (click)="onParentAccess(activeLocation.parent)"
                                (keydown.enter)="onParentAccess(activeLocation.parent)"
                                (keydown.space)="onParentAccess(activeLocation.parent)"
                                [ngStyle]="{cursor: 'pointer'}"
                            >
                                {{ activeLocation.parent.name }}
                            </a>
                            <span class="pi pi-chevron-right"></span>
                            <span [classList]="LocationUtils.getIconForType(activeLocation.type)"></span>
                            <span>{{ activeLocation.name }}</span>
                        } @else {
                            <span [classList]="LocationUtils.getIconForType(activeLocation.parent.type)"></span>
                            <a
                                tabindex="0"
                                (click)="onParentAccess(activeLocation.parent)"
                                (keydown.enter)="onParentAccess(activeLocation.parent)"
                                (keydown.space)="onParentAccess(activeLocation.parent)"
                                [ngStyle]="{cursor: 'pointer'}"
                                >{{ activeLocation.parent.name }}</a
                            >
                            <span class="pi pi-chevron-right"></span>
                            <span [classList]="LocationUtils.getIconForType(activeLocation.type)"></span>
                            <span>{{ activeLocation.name }}</span>
                        }
                    } @else {
                        <span [classList]="LocationUtils.getIconForType(activeLocation.type)"></span>&nbsp;{{
                            activeLocation.name
                        }}
                    }
                    <span class="mx-2">
                        <p-button
                            size="small"
                            (onClick)="locationCRUD?.onEdit(activeLocation)"
                            severity="primary"
                            icon="pi pi-pencil"
                        />
                        <p-button
                            size="small"
                            (onClick)="locationCRUD?.onDelete(activeLocation)"
                            [ngStyle]="{'margin-left': '0.25rem'}"
                            severity="danger"
                            icon="pi pi-trash"
                        />
                    </span>
                </h5>
                <div class="hcol-flex main-section">
                    <div class="hcol-66">
                        <p-panel header="Visuals" class="plain-header with-borders" styleClass="pictures">
                            @if (showLoading) {
                                <div style="text-align: center">
                                    <p-progressSpinner
                                        styleClass="w-4rem h-4rem"
                                        strokeWidth="4"
                                        animationDuration="1.5s"
                                    ></p-progressSpinner>
                                </div>
                            } @else {
                                <svg
                                    class="bd-placeholder-img card-img-top"
                                    height="100%"
                                    preserveAspectRatio="xMidYMid slice"
                                    role="img"
                                    width="100%"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect width="100%" height="100%" fill="var(--bs-secondary-bg)" />
                                    <svg
                                        x="30%"
                                        y="30%"
                                        width="40%"
                                        height="40%"
                                        viewBox="0 0 24 24"
                                        fill="var(--bs-tertiary-color)"
                                        aria-hidden="true"
                                    >
                                        <path
                                            d="M20.4 5.4a1.8 1.8 0 0 0-1.8-1.8h-15v15a1.8 1.8 0 0 0 1.8 1.8h15v-15ZM4.8 4.8h13.5a.9.9 0 0 1 .9.9V15l-4.61-5.237c-.167-.217-.436-.217-.602 0l-3.428 3.983-1.894-2.657c-.166-.217-.435-.217-.6 0L5.28 14.21c-.281-.211-.47-.444-.48-.926V4.8Zm4.8 3.25a1.5 1.5 0 1 1-3 .1 1.5 1.5 0 0 1 3-.1Z"
                                        ></path>
                                    </svg>
                                </svg>
                            }
                        </p-panel>
                    </div>

                    <div class="hcol-33">
                        <p-panel header="Attributes" class="plain-header with-borders" styleClass="attributes">
                            @if (showLoading) {
                                <div style="text-align: center">
                                    <p-progressSpinner
                                        styleClass="w-4rem h-4rem"
                                        strokeWidth="4"
                                        animationDuration="1.5s"
                                    ></p-progressSpinner>
                                </div>
                            } @else {
                                <p-panel
                                    header="Main characteristic"
                                    class="plain-header with-borders"
                                    [toggleable]="true"
                                >
                                    <div class="floatingLabelContainer">
                                        <p-floatlabel variant="on">
                                            <p-select
                                                inputId="type"
                                                [options]="typeOfLocationOptions"
                                                optionLabel="label"
                                                optionValue="value"
                                                [ngModel]="activeLocation.type"
                                                [disabled]="true"
                                                appendTo="body"
                                            ></p-select>
                                            <label for="type">Type</label>
                                        </p-floatlabel>

                                        <p-floatlabel variant="on">
                                            <p-treeSelect
                                                containerStyleClass="width-form"
                                                title="Select a parent for this location"
                                                emptyMessage="No parent location found"
                                                selectionMode="single"
                                                [ngModel]="activeLocationTreeNode?.parent"
                                                [disabled]="true"
                                                appendTo="body"
                                            ></p-treeSelect>
                                            <label for="parent_uuid">Parent location</label>
                                        </p-floatlabel>

                                        <p-floatlabel variant="on">
                                            <textarea
                                                id="description"
                                                rows="3"
                                                cols="30"
                                                pInputTextarea
                                                [ngModel]="activeLocation.description"
                                                [disabled]="true"
                                            ></textarea>
                                            <label for="description">Description</label>
                                        </p-floatlabel>
                                    </div>
                                </p-panel>

                                @let vec1Type = CPMLocationApiUtils.getVector1Type(activeLocation.type);
                                @let vec1Spec =
                                    CPMLocationApiUtils.getVectorTypeComponentSpec(vec1Type, activeLocation.type, 1);

                                @if (vec1Type !== ECPMLocationVectorTypeApiEnum.NONE) {
                                    <p-panel
                                        [header]="vec1Spec.hint"
                                        class="plain-header with-borders"
                                        [toggleable]="true"
                                    >
                                        <div class="floatingLabelContainer">
                                            @if (vec1Spec.components[0].enabled) {
                                                <p-inputgroup>
                                                    <p-floatlabel variant="on">
                                                        <p-inputnumber
                                                            inputId="x1"
                                                            mode="decimal"
                                                            [useGrouping]="false"
                                                            [ngModel]="activeLocation.x1"
                                                            [disabled]="true"
                                                        />
                                                        <label for="x1">{{ vec1Spec.components[0].hint }}</label>
                                                    </p-floatlabel>
                                                    <p-inputgroup-addon>{{
                                                        vec1Spec.components[0].unitHint
                                                    }}</p-inputgroup-addon>
                                                </p-inputgroup>
                                            }
                                            @if (vec1Spec.components[1].enabled) {
                                                <p-inputgroup>
                                                    <p-floatlabel variant="on">
                                                        <p-inputnumber
                                                            inputId="y1"
                                                            mode="decimal"
                                                            [useGrouping]="false"
                                                            [ngModel]="activeLocation.y1"
                                                            [disabled]="true"
                                                        />
                                                        <label for="y1">{{ vec1Spec.components[1].hint }}</label>
                                                    </p-floatlabel>
                                                    <p-inputgroup-addon>{{
                                                        vec1Spec.components[1].unitHint
                                                    }}</p-inputgroup-addon>
                                                </p-inputgroup>
                                            }
                                            @if (vec1Spec.components[2].enabled) {
                                                <p-inputgroup>
                                                    <p-floatlabel variant="on">
                                                        <p-inputnumber
                                                            inputId="z1"
                                                            mode="decimal"
                                                            [useGrouping]="false"
                                                            [ngModel]="activeLocation.z1"
                                                            [disabled]="true"
                                                        />
                                                        <label for="z1">{{ vec1Spec.components[2].hint }}</label>
                                                    </p-floatlabel>
                                                    <p-inputgroup-addon>{{
                                                        vec1Spec.components[2].unitHint
                                                    }}</p-inputgroup-addon>
                                                </p-inputgroup>
                                            }
                                        </div>
                                    </p-panel>
                                }

                                @let vec2Type = CPMLocationApiUtils.getVector2Type(activeLocation.type);
                                @let vec2Spec =
                                    CPMLocationApiUtils.getVectorTypeComponentSpec(vec2Type, activeLocation.type, 2);

                                @if (vec2Type !== ECPMLocationVectorTypeApiEnum.NONE) {
                                    <p-panel
                                        [header]="vec2Spec.hint"
                                        class="plain-header with-borders"
                                        [toggleable]="true"
                                    >
                                        <div class="floatingLabelContainer">
                                            @if (vec2Spec.components[0].enabled) {
                                                <p-inputgroup>
                                                    <p-floatlabel variant="on">
                                                        <p-inputnumber
                                                            inputId="x2"
                                                            mode="decimal"
                                                            [useGrouping]="false"
                                                            [ngModel]="activeLocation.x2"
                                                            [disabled]="true"
                                                        />
                                                        <label for="x2">{{ vec2Spec.components[0].hint }}</label>
                                                    </p-floatlabel>
                                                    <p-inputgroup-addon>{{
                                                        vec2Spec.components[0].unitHint
                                                    }}</p-inputgroup-addon>
                                                </p-inputgroup>
                                            }
                                            @if (vec2Spec.components[1].enabled) {
                                                <p-inputgroup>
                                                    <p-floatlabel variant="on">
                                                        <p-inputnumber
                                                            inputId="y2"
                                                            mode="decimal"
                                                            [useGrouping]="false"
                                                            [ngModel]="activeLocation.y2"
                                                            [disabled]="true"
                                                        />
                                                        <label for="y2">{{ vec2Spec.components[1].hint }}</label>
                                                    </p-floatlabel>
                                                    <p-inputgroup-addon>{{
                                                        vec2Spec.components[1].unitHint
                                                    }}</p-inputgroup-addon>
                                                </p-inputgroup>
                                            }
                                            @if (vec2Spec.components[2].enabled) {
                                                <p-inputgroup>
                                                    <p-floatlabel variant="on">
                                                        <p-inputnumber
                                                            inputId="z2"
                                                            mode="decimal"
                                                            [useGrouping]="false"
                                                            [ngModel]="activeLocation.z2"
                                                            [disabled]="true"
                                                        />
                                                        <label for="z2">{{ vec2Spec.components[2].hint }}</label>
                                                    </p-floatlabel>
                                                    <p-inputgroup-addon>{{
                                                        vec2Spec.components[2].unitHint
                                                    }}</p-inputgroup-addon>
                                                </p-inputgroup>
                                            }
                                        </div>
                                    </p-panel>
                                }

                                @if (CPMLocationApiUtils.hasSlotCount(activeLocation.type)) {
                                    <p-panel header="Slot count" class="plain-header with-borders" [toggleable]="true">
                                        <div class="floatingLabelContainer">
                                            <p-inputgroup>
                                                <p-floatlabel variant="on">
                                                    <p-inputnumber
                                                        inputId="slot_count"
                                                        [ngModel]="activeLocation.slot_count"
                                                        mode="decimal"
                                                        [useGrouping]="false"
                                                        [disabled]="true"
                                                    />
                                                    <label for="slot_count">Slot count</label>
                                                </p-floatlabel>
                                                <p-inputgroup-addon> u </p-inputgroup-addon>
                                            </p-inputgroup>
                                        </div>
                                    </p-panel>
                                }
                            }
                        </p-panel>
                    </div>
                </div>

                @if (CPMLocationApiUtils.getAllowedChildrenType(activeLocation.type).length > 0) {
                    <div class="mb-3"></div>

                    <p-panel [header]="'Sub locations of: ' + activeLocation.name" class="plain-header with-borders">
                        <app-location-crud
                            [focusParent]="activeLocation"
                            [fnOverrideOnAccess]="onChildrenAccess.bind(this)"
                            [fnOnModalResult]="onCRUDModalResult.bind(this)"
                            [fnOnDeleteResult]="onCRUDDeleteResult.bind(this)"
                            [parentShowingLoading]="showLoading"
                        ></app-location-crud>
                    </p-panel>
                }

                <div class="mb-3">&nbsp;</div>
            }
        </div>
    </div>
</div>
